import { LectureVideo, VideoQuality } from './types';

const PREFERRED_QUALITY_STORAGE_KEY = 'vsimavec-preferred-video-quality';

export function getVideoQualities(video: LectureVideo): VideoQuality[] {
    if (video.qualities?.length) {
        return [...video.qualities].sort((a, b) => b.height - a.height);
    }

    return [{ label: 'Původní', height: 0, url: video.url }];
}

export function hasMultipleVideoQualities(video: LectureVideo): boolean {
    return (video.qualities?.length ?? 0) > 1;
}

export function getPreferredVideoQualityHeight(): number | null {
    const stored = localStorage.getItem(PREFERRED_QUALITY_STORAGE_KEY);

    if (!stored) return null;

    const height = Number(stored);
    return Number.isFinite(height) ? height : null;
}

export function setPreferredVideoQualityHeight(height: number) {
    localStorage.setItem(PREFERRED_QUALITY_STORAGE_KEY, String(height));
}

export function clearPreferredVideoQualityHeight() {
    localStorage.removeItem(PREFERRED_QUALITY_STORAGE_KEY);
}

export function getInitialVideoQuality(video: LectureVideo): VideoQuality {
    const qualities = getVideoQualities(video);
    const preferredHeight = getPreferredVideoQualityHeight();

    if (preferredHeight !== null) {
        const preferred = qualities.find(
            (quality) => quality.height === preferredHeight
        );
        if (preferred) return preferred;
    }

    return qualities[0];
}
